import { Box } from '@mui/material';

// import { Column } from '../../../../types';
// import {
//   CloudCoverTableResponseType,
//   TFieldDetails,
// } from '../../../../types/mvpCharts';
// import dayjs from 'dayjs';
import { MVPFormData } from '../../constants';
import React from 'react';
// import { useLazyGetCloudCoverDetailsQuery } from '../../../../services/mVPGraphQlService';
// import { useAlertHelper } from '../../../../utils/functions/hooks';

type TProps = {
  fieldNumbers: number[];
  startTime: number;
  endTime: number;
  commonFilters: MVPFormData;
};

const TimeSeriesChartTable: React.FC<TProps> = () => {
  // const { showError } = useAlertHelper();
  // // const [pageNo, setPageNo] = useState(0);
  // const [pageSize, setPageSize] = useState(100);
  // const [tableData, setTableData] = useState<
  //   TFieldDetails[]
  // >([]);
  // const [totalCount, setTotalCount] = useState<number>(0);
  // const [allTableData, setAllTableData] = useState<
  //   TFieldDetails[]
  // >([]);
  // const [data, setData] = useState<TFieldDetails[]>([]);
  // const [isFetching, setIsFetching] =
  //   useState<boolean>(false);

  // const previousFieldNumbers = useRef<number[]>([]);

  // useEffect(() => {
  //   if (fieldNumbers.length === 0) {
  //     resetTableData();
  //   } else {
  //     if (
  //       fieldNumbers.length !==
  //         previousFieldNumbers.current.length ||
  //       !fieldNumbers.every(
  //         (val, index) =>
  //           val === previousFieldNumbers.current[index]
  //       )
  //     ) {
  //       getTableDetails();
  //     }
  //   }

  //   previousFieldNumbers.current = fieldNumbers;
  // }, [fieldNumbers]);

  // useEffect(() => {
  //   const fieldDetails = data;
  //   if (fieldDetails && fieldDetails.length > 0) {
  //     setSowingTime?.(
  //       fieldDetails[0]?.sowingTime?.seconds
  //         ? {
  //             seconds: fieldDetails[0].sowingTime.seconds,
  //           }
  //         : null
  //     );

  //     if (fieldDetails[0]?.harvestTime?.seconds) {
  //       const harvestDate = dayjs(
  //         fieldDetails[0].harvestTime.seconds * 1000
  //       );
  //       const currentDate = dayjs();
  //       setHarvestTime?.({
  //         seconds: harvestDate?.isBefore(currentDate)
  //           ? fieldDetails[0].harvestTime.seconds
  //           : Math.floor(currentDate.valueOf() / 1000),
  //       });
  //     } else {
  //       setHarvestTime?.({
  //         seconds: Math.floor(Date.now() / 1000),
  //       });
  //     }
  //   }
  // }, [data, setSowingTime, setHarvestTime]);

  // const [fetchTableDetails] =
  //   useLazyGetCloudCoverDetailsQuery();

  // // const columns: Column<
  // //   TFieldDetails,
  // //   keyof TFieldDetails
  // // >[] = [
  // //   {
  // //     key: 'fieldNumber',
  // //     label: 'Field Number',
  // //     cellModifier(data) {
  // //       return (
  // //         <Typography fontSize={13} fontWeight={600}>
  // //           {data?.fieldNumber}
  // //         </Typography>
  // //       );
  // //     },
  // //   },
  // //   {
  // //     key: 'geographyData',
  // //     label: 'Region',
  // //     cellModifier(data) {
  // //       return data?.geographyData?.region;
  // //     },
  // //   },
  // //   {
  // //     key: 'indexTime',
  // //     label: 'Village',
  // //     cellModifier(data) {
  // //       return data?.geographyData?.village;
  // //     },
  // //   },
  // //   {
  // //     key: 'registeredArea',
  // //     label: 'Registered Area',
  // //     cellModifier(data) {
  // //       return data?.registeredArea;
  // //     },
  // //   },
  // //   {
  // //     key: 'geofenceArea',
  // //     label: 'Geofence Area',
  // //     cellModifier(data) {
  // //       return data?.geofenceArea?.toFixed(2);
  // //     },
  // //   },
  // //   {
  // //     key: 'areaUnderReported',
  // //     label: 'Area Under reported',
  // //     cellModifier(data) {
  // //       return data?.areaUnderReported?.toFixed(2);
  // //     },
  // //   },
  // //   {
  // //     key: 'growerName',
  // //     label: 'Grower Name',
  // //     cellModifier(data) {
  // //       return data?.growerName;
  // //     },
  // //   },
  // //   {
  // //     key: 'employeeData',
  // //     label: 'Organizer',
  // //     cellModifier(data) {
  // //       return data?.employeeData?.organizer;
  // //     },
  // //   },
  // //   {
  // //     key: 'indexName',
  // //     label: 'FA',
  // //     cellModifier(data) {
  // //       return data?.employeeData?.fa;
  // //     },
  // //   },
  // //   {
  // //     key: 'sowingTime',
  // //     label: 'Sowing Date',
  // //     cellModifier(data) {
  // //       return dayjs(
  // //         data?.sowingTime?.seconds
  // //           ? data?.sowingTime?.seconds * 1000
  // //           : 0
  // //       ).format('DD/MM/YYYY');
  // //     },
  // //   },
  // //   {
  // //     key: 'harvestTime',
  // //     label: 'Harvest Date',
  // //     cellModifier(data) {
  // //       return data?.harvestTime?.seconds == 0
  // //         ? '-'
  // //         : dayjs(
  // //             data?.harvestTime?.seconds
  // //               ? data?.harvestTime?.seconds * 1000
  // //               : 0
  // //           ).format('DD/MM/YYYY');
  // //     },
  // //   },
  // //   {
  // //     key: 'harvestQuantity',
  // //     label: 'Harvest Quantity',
  // //     cellModifier(data) {
  // //       return data?.harvestQuantity;
  // //     },
  // //   },
  // //   {
  // //     key: 'latestTime',
  // //     label: 'Index Time',
  // //     cellModifier(data) {
  // //       return data?.fieldIndexList?.length &&
  // //         data?.fieldIndexList[0].indexTime?.seconds
  // //         ? dayjs(
  // //             data?.fieldIndexList[0].indexTime?.seconds *
  // //               1000
  // //           ).format('DD/MM/YYYY')
  // //         : '-';
  // //     },
  // //   },
  // //   {
  // //     key: 'latestIndexValue',
  // //     label: 'Index Value',
  // //     cellModifier(data) {
  // //       return data?.fieldIndexList?.length &&
  // //         data?.fieldIndexList[0]?.averageIndex
  // //         ? data?.fieldIndexList[0]?.averageIndex?.toFixed(
  // //             3
  // //           )
  // //         : '-';
  // //     },
  // //   },
  // // ];

  // const getTableDetails = () => {
  //   setIsFetching(true);
  //   fetchTableDetails({
  //     thresholdCover: 0,
  //     startTime,
  //     endTime,
  //     commonFilters,
  //     fieldNumbers,
  //   })
  //     .unwrap()
  //     .then((response) => {
  //       if (
  //         response?.data?.GetFieldDetailsForFieldNumbers
  //           ?.fieldDetails?.length
  //       ) {
  //         const transformedData = transformFieldDetails(
  //           response?.data?.GetFieldDetailsForFieldNumbers
  //             ?.fieldDetails
  //         );
  //         getTablePaginatedData(transformedData);
  //         setData(transformedData);
  //       } else {
  //         resetTableData();
  //       }
  //       setIsFetching(false);
  //     })
  //     .catch((err) => {
  //       console.log('err', err);
  //       resetTableData();
  //       setIsFetching(false);
  //     });
  // };

  // const handleDownloadCsv = () => {
  //   fetchTableDetails({
  //     thresholdCover: 0,
  //     startTime,
  //     endTime,
  //     commonFilters,
  //     fieldNumbers,
  //     downloadCsv: true,
  //   })
  //     .unwrap()
  //     .then((response) => {
  //       const url =
  //         response?.data?.GetFieldDetailsForFieldNumbers
  //           ?.csvPresignedUrl;
  //       window.open(url, '_blank');
  //     })
  //     .catch(() => {
  //       showError('Error while downloading file');
  //     });
  // };

  // const transformFieldDetails = (
  //   fieldDetails: CloudCoverTableResponseType[]
  // ) => {
  //   const formattedList = fieldDetails.map((field) => ({
  //     fieldNumber: field?.fieldNumber, // Keep fieldNumber
  //     fieldGeomData: field?.fieldGeomData, // Keep fieldGeomData as is
  //     fieldIndexList: field?.fieldIndexList, // Keep fieldIndexList as is
  //     ...field?.fieldDetails, // Spread all properties from fieldDetails directly
  //   }));

  //   const transformedDetails = formattedList?.flatMap(
  //     (obj) => {
  //       if (
  //         obj?.fieldIndexList?.length &&
  //         obj?.fieldIndexList?.length > 1
  //       ) {
  //         return obj?.fieldIndexList?.map((index) => ({
  //           ...obj,
  //           fieldIndexList: [index], // Each object gets its own index entry
  //         }));
  //       }
  //       return obj; // Return the original object if no duplication is needed
  //     }
  //   );
  //   return transformedDetails;
  // };

  // const resetTableData = () => {
  //   setTotalCount(0);
  //   setTableData([]);
  //   setAllTableData([]);
  // };

  // const getTablePaginatedData = (
  //   fieldDetails: TFieldDetails[]
  // ) => {
  //   // setPageNo(0);
  //   if (fieldDetails?.length) {
  //     setTotalCount(fieldDetails?.length);
  //     setTableData(
  //       getPaginatedData(0, pageSize, fieldDetails)
  //     );
  //     setAllTableData(fieldDetails);
  //   } else {
  //     setTotalCount(0);
  //     setTableData([]);
  //     setAllTableData([]);
  //   }
  // };

  // const handlePageChange = (
  //   event: React.MouseEvent | null,
  //   newPageNumber: number
  // ) => {
  //   setTableData(
  //     getPaginatedData(
  //       newPageNumber,
  //       pageSize,
  //       allTableData
  //     )
  //   );
  // };

  // const getPaginatedData = (
  //   newPageNumber: number,
  //   itemsPerPage: number,
  //   allItemsList: TFieldDetails[]
  // ) => {
  //   const indexOfLastItem =
  //     (newPageNumber + 1) * itemsPerPage;
  //   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  //   const currentPageItems = allItemsList?.slice(
  //     indexOfFirstItem,
  //     indexOfLastItem
  //   );
  //   return [...currentPageItems];
  // };

  return (
    <Box className="mt-16">
      {/* <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
        }}>
        <h1 className="text-lg py-2 title-text-container">
          Time Series Data ({commonFilters?.index})
          <Button
            variant="button--secondary"
            onClick={() => handleDownloadCsv()}
            disabled={tableData?.length > 0 ? false : true}>
            Download
          </Button>
        </h1>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}>
          <div
            style={{
              width: 16,
              height: 2,
              backgroundColor: '#FDAF20',
              marginRight: 8,
            }}
          />
          <span
            style={{ fontWeight: 500, fontSize: '16px' }}>
            PLD Fields
          </span>
        </div>
      </div> */}
      {/* <Table
        columns={columns}
        data={tableData?.length ? tableData : []}
        rowsPerPage={pageSize}
        rowKey={'fieldNumber'}
        setRowsPerPage={setPageSize}
        count={totalCount}
        page={pageNo}
        setPage={setPageNo}
        isLoading={isFetching}
        rowsPerPageOptions={[pageSize]}
        pageChangeHandler={handlePageChange}
        type={'TimeSeries'}
      /> */}
    </Box>
  );
};

export default React.memo(TimeSeriesChartTable);
